/**
 * The product key of the configuration the configurator opens with.
 *
 * The host names it in the `model` URL param. When the param is missing, or
 * holds the literal `undefined` that an earlier save wrote into a
 * configuration ID, the key falls back to the one inside the Roomle ID:
 * `vallone:<key>` for a master, `vallone:<key>:<hash>` for a saved
 * configuration.
 */
export const resolveProductKey = (roomleId: string, model?: string | null): string => {
  if (model && model !== 'undefined') {
    return model;
  }

  return roomleId.split(':')[1];
};
